<template>
  <v-dialog v-model="value" persistent fullscreen scrollable>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title> <img :src="tool.icon" class="tool-image" />Bulk Change Update Objective</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon flat @click.stop="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <div
        v-if="state !== BulkOperationState.waitingForFiles"
        style="
          position: absolute;
          top: 65px;
          bottom: 0px;
          height: calc(100% - 65px);
          width: 350px;
          border-right: rgba(0, 0, 0, 0.12) solid thin;
        ">
        <div v-if="state == BulkOperationState.userInput">
          <v-alert :value="true" type="info">
            This action will create a new revision of a guide converted to Interactive Presentation.
          </v-alert>
          <v-divider class="custom-id-divider"></v-divider>
        </div>
        <div style="position: absolute; bottom: 0px; padding: 10px; width: 100%">
          <v-divider></v-divider>
          <v-btn color="success" block outline @click.stop="startConversion" v-if="state == BulkOperationState.userInput">
            <v-icon left>mdi-play</v-icon>Start Upload
          </v-btn>
          <v-btn color="red" block outline @click.stop="state = BulkOperationState.cancelled" v-if="state == BulkOperationState.uploading">
            <v-icon left>mdi-stop</v-icon>Cancel Upload
          </v-btn>
          <v-btn color="primary" block outline @click.stop="close()" v-if="state == BulkOperationState.completed">
            <v-icon left>mdi-close</v-icon>Close
          </v-btn>
        </div>
        <bulk-upload-progress v-if="state == BulkOperationState.completed || state == BulkOperationState.uploading" :items="updateContents" />
      </div>
      <bulk-change-custom-id-table
        v-if="state !== BulkOperationState.waitingForFiles"
        :contents="updateContents"
        :disabled="state !== BulkOperationState.userInput" />
      <template v-if="state == BulkOperationState.waitingForFiles">
        <bulk-change-custom-id-upload-xls @upload-finished="manageFiles" />
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import BulkChangeCustomIdUploadXls from "./components/UploadXls.vue"
import BulkChangeCustomIdTable from "./components/Table.vue"
import BulkUploadProgress from "@/pages/explorer/ExploreLibrary/components/BulkUpload/Progress.vue"
import convert from "./convert"
import { BulkOperationState } from "plant-common/src/models/bulkOperationState"
import { ContentOperationStatus } from "plant-common/src/models/contentOperationStatus"

export default {
  props: {
    tool: Object
  },
  components: {
    BulkChangeCustomIdUploadXls,
    BulkChangeCustomIdTable,
    BulkUploadProgress
  },
  data: () => ({
    BulkOperationState,
    value: true,
    state: BulkOperationState.waitingForFiles,
    updateContents: []
  }),
  computed: {},
  methods: {
    close() {
      this.value = false
    },
    manageFiles(contents) {
      this.updateContents = contents
      this.state = BulkOperationState.userInput
    },
    async startConversion() {
      this.state = BulkOperationState.uploading
      for (var content of this.updateContents) {
        content.status = ContentOperationStatus.inProgress
        if (this.state == BulkOperationState.cancelled) {
          content.status = ContentOperationStatus.error
        } else {
          try {
            await convert(content)
            content.status = ContentOperationStatus.done
          } catch (error) {
            console.error(error)
            content.status = ContentOperationStatus.error
            content.error = error
          }
        }
      }
      this.state = BulkOperationState.completed
    }
  }
}
</script>

<style scoped>
.tool-image {
  max-height: 40px;
}

.custom-id-divider {
  margin-top: 25px;
  margin-bottom: 25px;
}
</style>
